<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouveau code promotionnel')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'PromoCodeContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/commerce/codes-promotionnels/nouveau-code-promotionnel')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/commerce/codes-promotionnels/nouveau-code-promotionnel'))
                }
            }
        }
    }
</script>
